module.exports = __webpack_public_path__ + "static/media/map2.b6a8fad6.png";